import axios from "axios";

export const loginApi = async (credintial, lang) => {
  let data = JSON.stringify({
    email: credintial.email,
    password: credintial.password,
  });

  let config = {
    method: "post",
    url: `${process.env.REACT_APP_API}/login`,
    headers: {
      lan: lang,
      "Content-Type": "application/json",
      Authorization: "Basic YWRtaW5AdGhvdGhvOnEzem92QlNBMTk5NyEh",
    },
    data: data,
    timeout: 15000,
  };

  try {
    const res = await axios(config);
    return { success: res.data.success, res: res };
  } catch (error) {
    return { success: false, res: error };
  }
};
